import axios from 'axios';

import { AuthInterceptor, AuthService } from '@sine/auth-client';

import { sessionStorage, storage } from '../storage/storage.service';
import { startInterceptingBeforeAuthClient } from './axios.interceptor';
import deviceService from './device.service';

function hasBasicAuth() {
  return !!storage.getItem('refreshToken');
}

const authService = new AuthService({
  authApiUrl: window.env.REACT_APP_SINE_ID_API_ENDPOINT || '',
  coreAuthApiUrl: window.env.REACT_APP_SINE_CORE_API_ENDPOINT || '',
  rootClientUrl: `${window.location.origin}${window.env.PUBLIC_URL}`,
  rootClientAuthApiUrl: window.env.REACT_APP_SINE_WEB_CHECK_IN_API_ENDPOINT,
  storage,
  sessionStorage,
  authMode: hasBasicAuth() ? 'basic' : 'recaptcha',
  axiosInstance: axios,
});

const authInterceptor = new AuthInterceptor(axios, authService);

startInterceptingBeforeAuthClient(axios);
authInterceptor.startIntercepting();

/**
 * Wait until the device service has grabbed itself a token and then attempt
 * to initialise the auth service!
 */
let registeredDeviceToken: string | undefined;
function handleDeviceTokenChanged(newDeviceToken: string | undefined) {
  if (registeredDeviceToken && registeredDeviceToken !== newDeviceToken) {
    // Authentication previously performed with different device token, nothing we can do here.
    registeredDeviceToken = undefined;
    authService.trashUser();
    window.location.reload();
  } else if (newDeviceToken) {
    // Device token is ready, let's try and initialise
    registeredDeviceToken = newDeviceToken;
    authService.initialize(false);
  }
}

handleDeviceTokenChanged(deviceService.getDeviceToken());
deviceService.addDeviceTokenListener(handleDeviceTokenChanged);

export default authService;
